var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4001_34462)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4412 14.5083C7.52179 14.5083 4.34082 16.0988 4.34082 18.0585C4.34082 19.649 6.42833 20.991 9.31108 21.4454V23.7388L12.1512 20.8987L9.31108 18.0585V19.9969C7.07446 19.5993 5.76089 18.6478 5.76089 18.0585C5.76089 17.3059 7.91941 15.9284 11.4412 15.9284C14.963 15.9284 17.1215 17.3059 17.1215 18.0585C17.1215 18.5768 16.0848 19.4005 14.2813 19.8549V21.3105C16.7878 20.7637 18.5416 19.5141 18.5416 18.0585C18.5416 16.0988 15.3606 14.5083 11.4412 14.5083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5532 -0.0166016C7.81968 -0.0166016 4.80009 3.00299 4.80009 6.73647C4.80009 11.8013 11.5532 19.2779 11.5532 19.2779C11.5532 19.2779 18.3062 11.8013 18.3062 6.73647C18.3062 3.00299 15.2866 -0.0166016 11.5532 -0.0166016ZM11.5533 9.14834C10.222 9.14834 9.1415 8.06785 9.1415 6.73653C9.1415 5.40521 10.222 4.32472 11.5533 4.32472C12.8846 4.32472 13.9651 5.40521 13.9651 6.73653C13.9651 8.06785 12.8846 9.14834 11.5533 9.14834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_34462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/iconLocation.0bbcebbe334db3f5c7ba3d24e6668ca2.svg";
export { ForwardRef as ReactComponent };